export const filterPreviews = {
    "quickpoint::author": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/5c24045e-0f1f-42f2-c348-864aa196a800/public",
    "quickpoint::caruso-black": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/a60efdbb-0173-4e3e-6cb3-a62a07113a00/public",
    "quickpoint::caruso-console": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/d9fb104c-2449-4313-5e4a-5110b7172d00/public",
    "quickpoint::caruso-corp": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/596ea98c-2e30-4477-ed45-581c4ae67d00/public",
    "quickpoint::caruso-italia": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/2c26fcd2-75d7-41cc-33cc-92cba82eca00/public",
    "quickpoint::caruso": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/00c3f3b5-ea31-4969-0fa0-ac49d5e02000/public",
    "quickpoint::default": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/0d7efd47-9aee-472b-b4af-e47cce684900/public",
    "quickpoint::menu-cards": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/ad13548f-234d-461a-7b5e-89f03aba2a00/public",
    "quickpoint::nyt": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/7d2e2ac0-6c60-49c6-138c-f3c83fb5eb00/public",
    "quickpoint::tufte": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/d9a30803-6741-4458-8245-8895eaa56e00/public",
    "quickpoint::tufte-sans": "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/1d5c7c97-4f45-48f4-fccb-6dd8bb659a00/public"
}




